import { useState, useEffect } from 'react';
import { attachmentsAPI } from '../api/client';

export const useAttachmentCounts = (entityType, entityIds) => {
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!entityIds || entityIds.length === 0) {
      setCounts({});
      return;
    }

    loadCounts();
  }, [entityType, entityIds.join(',')]);

  const loadCounts = async () => {
    try {
      setLoading(true);
      const response = await attachmentsAPI.getAttachmentCounts(entityType, entityIds);
      
      if (response.data.success) {
        setCounts(response.data.counts);
      }
    } catch (err) {
      console.error('Error loading attachment counts:', err);
    } finally {
      setLoading(false);
    }
  };

  const refreshCounts = () => {
    loadCounts();
  };

  return { counts, loading, refreshCounts };
};